import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  standalone: false
})
export class ProgressBarComponent {
  @Input() value: number = 0;
  @Input() color: 'primary' | 'grey' = 'primary';
  @Input() height: string = '1rem';
  @Input() width: string = '100%';
}
